/**
 * Clipped out of sight but left in the accessibility tree — MUI's own
 * `visuallyHidden`, written out rather than imported: `@mui/utils` is a
 * transitive dependency here, not a direct one, and adding a package to the
 * admin app for one style object is a worse trade than seven lines.
 *
 * Not `display: none` or `visibility: hidden`, either of which would take the
 * announcement out of the tree along with the pixels.
 *
 * Lifted out of `admin-empty.tsx` (CAE-1540) when Edit › Fixtures' selection
 * ribbon needed the same thing (CAE-1550): the ribbon draws "3" and "fixtures
 * selected" as two flex children, so the sentence a screen reader concatenates
 * is "3fixtures selected" unless the real one is supplied beside it.
 */
export const VISUALLY_HIDDEN = {
  position: 'absolute',
  // '1px', not 1: MUI's sizing transform reads a bare number in 0..1 as a
  // fraction, so `width: 1` would resolve to 100% and stretch the region across
  // the page. Clipped either way, but it is still an absolutely positioned
  // full-width box sitting over the layout.
  width: '1px',
  height: '1px',
  overflow: 'hidden',
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  whiteSpace: 'nowrap',
} as const;
